const getSubscriptionsByConsentCheckboxes = ({
  subscriptionDefinitions,
  legalConsentCopy
}) => {
  const ids = Object.keys(legalConsentCopy.consentCheckboxes);
  return subscriptionDefinitions.filter(subscriptionDefinition => {
    return ids.indexOf(String(subscriptionDefinition.id)) > -1;
  });
};
export default getSubscriptionsByConsentCheckboxes;